import React, { useState } from "react";
import violentometro from './images/violentometro.png';
import derechoslegales from './images/derechoslegales.jpeg';
import apoyopsicologico from './images/apoyopsicologico.jpeg';
import violenciafisica from './images/violenciafisica.avif';
import violenciaPsicologica from './images/violenciaPsicologica.jpeg';
import ViolenciaSexual from './images/ViolenciaSexual.jpeg';
import ViolenciaEconomica from './images/ViolenciaEconomica.jpeg';
import ViolenciaSimbolica from './images/ViolenciaSimbolica.jpeg';
import ViolenciaPatrimonial from './images/ViolenciaPatrimonial.avif';
import evento1 from './images/accesos/CentrosJusticia.jpg';
import evento2 from './images/accesos/Num_Emergencia.png';
import evento3 from './images/accesos/Test.png';
import evento4 from './images/accesos/Podcast.jpg';
import { useNavigate } from 'react-router-dom';


const AccesosDirectos = ({ title, content }) => {

    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate('/test');
    }
    const handleMapaRedirect = () => {
        navigate('/numeros-de-emergencia');
    };


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen1, setIsModalOpen1] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const openModal1 = () => setIsModalOpen1(true);
    const closeModal1 = () => setIsModalOpen1(false);

    const whatsappUrl1 = "https://wa.me/522221133330?text=Hola%20Psicóloga%20Diana%20Serrano,%20vengo%20del%20sitio%20Caminemos%20Juntas%20me%20gustaría%20tener%20una%20asesoría.";
    const whatsappUrl = "https://wa.me/529531776747?text=Hola%20Licenciada%20Gabriela%20Sarabia,%20vengo%20del%20sitio%20Caminemos%20Juntas%20me%20gustaría%20tener%20una%20asesoría.";


  return (
    <div className="bg-[#fff8f1] text-center font-sans text-[#24363a]">
        
       
        <section id="test" className="mx-auto max-w-7xl px-5 py-12 text-gray-800 sm:px-8">
            <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#26756f]">Recursos a tu alcance</p>
            <h2 className="mt-2 text-3xl font-bold text-[#173f46] sm:text-4xl">Encuentra apoyo y conoce tus opciones</h2>
            <p className="mx-auto mt-3 max-w-2xl text-base text-gray-600">Accede rápidamente a herramientas de orientación, centros de ayuda y acompañamiento.</p>
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {/* Card 1 */}
                <div className="flex flex-col rounded-lg border-t-4 border-[#26756f] bg-white p-4 text-center shadow-lg">
                <img src={evento1} alt="Directorio Centros" className="w-full h-32 object-cover mb-4 rounded-md" />
                <h3 className="text-lg font-semibold">Directorio Centros de Justicia</h3>
                <p className="text-sm text-gray-600 mt-2">Consulta centros de justicia disponibles.</p>
                <a
                    href="https://www.gob.mx/cms/uploads/attachment/file/715487/Directorio_Nacional_CJM_2024.pdf" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="mt-auto inline-block rounded-md bg-[#26756f] px-4 py-3 font-semibold text-white hover:bg-[#1d5d58]"
                    >
                    Ver Directorio
                </a>
                </div>

                {/* Card 2 */}
                <div id="estamoscontigo" className="flex flex-col rounded-lg border-t-4 border-[#f2c14e] bg-white p-4 text-center shadow-lg">
                <img src={evento2} alt="Mapa de Centros" className="w-full h-32 object-cover mb-4 rounded-md" />
                <h3 className="text-lg font-semibold">Mapa de Centros de Atención</h3>
                <p className="text-sm text-gray-600 mt-2">Encuentra el centro más cercano.</p>
                <button onClick={handleMapaRedirect} className="mt-auto rounded-md bg-[#d99822] px-4 py-3 font-semibold text-white hover:bg-[#b87c13]">
                    Ver mapa
                </button>
                </div>

                {/* Card 3 */}
                <div className="flex flex-col rounded-lg border-t-4 border-[#c94b4b] bg-white p-4 text-center shadow-lg">
                <img src={evento3} alt="Test Interactivo" className="w-full h-32 object-cover mb-4 rounded-md" />
                <h3 className="text-lg font-semibold">Test Interactivo</h3>
                <p className="text-sm text-gray-600 mt-2">Evalúa tu situación con el violentómetro.</p>
                <button onClick={handleRedirect} className="mt-auto rounded-md bg-[#c94b4b] px-4 py-3 font-semibold text-white hover:bg-[#a83e3e]">
                    Ir al test
                </button>
                </div>

                {/* Card 4 */}
                <div className="flex flex-col rounded-lg border-t-4 border-[#d99822] bg-white p-4 text-center shadow-lg">
                <img src={evento4} alt="Podcast" className="w-full h-32 object-cover mb-4 rounded-md" />
                <h3 className="text-lg font-semibold">Podcast</h3>
                <p className="text-sm text-gray-600 mt-2">Escucha historias y orientación de expertas.</p>
                <a 
                    href="https://open.spotify.com/show/7BgmoCm7maMCX0wUeN7p8l?si=hi1zt2OkQCq9NHaaR0A0Gg&nd=1&dlsi=a86e6966077748ac" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="mt-auto inline-block rounded-md bg-[#26756f] px-4 py-3 font-semibold text-white hover:bg-[#1d5d58]"
                    >
                    Escuchar
                </a>

                </div>
            </div>
        </section>

    </div>
  );
};

export default AccesosDirectos;
